export default "\n<div class=\"footer-copyright text-center py-3 footerDes\">© 2019 Copyright:\n    <a> KSSL2019 Team</a>\n</div>\n\n      "